import * as yup from "yup";
import { isValidPhoneNumberFormat } from "config/constants";
import { ValidateEmail } from "utils";

export const StepOneValidation = yup.object({
  client_address: yup.object({
    place_id: yup.string().required(),
    address: yup.string().required()
  }),
  client_company_name: yup.string().required(),
  client_activity: yup.string().required()
});

export const StepSecondValidation = yup.object({
  client_contact_firstname: yup.string().required(),
  client_contact_lastname: yup.string().required(),
  client_contact_job: yup.string().required(),
  client_contact_email: yup.string().required().test((value:any, {path, createError}: any)=>{
    if(!ValidateEmail(String(value))){
      return createError({path, message: "Enter a valid email please"});
    }
    return true;
  }),
  client_contact_phone_number: yup
    .string()
    .required()
    .test((value: any, { path, createError }: any) => {
      if (!isValidPhoneNumberFormat(String(value))) {
        return createError({ path, message: "Invalid phone number" });
      }
      return true;
    })
});

